import { useQuery } from '@tanstack/react-query';

import { queryKeys, useApi } from 'shared/api/model';

export const useInstallations = (
  enabled = true,
  { poll = false }: { poll?: boolean } = {},
) => {
  const api = useApi('InstallationsApi');
  const { queryKey } = queryKeys.installations.list;

  return useQuery({
    queryKey,
    enabled,
    queryFn: () => api.listInstallations(),
    staleTime: 0, // Always refetch — installation access can change between sessions
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
    refetchInterval: poll ? 3000 : false,
  });
};
